<script>
import feather from 'feather-icons';
import AppHeaderLinks from './AppHeaderLinks.vue';

export default {
	components: {
		AppHeaderLinks,
	},
	props: {
		// Personal pages keep the logo alone: the menu offers destinations that
		// compete with the two contacts such a page exists for.
		minimal: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isOpen: false,
		};
	},
	mounted() {
		feather.replace();
	},
	updated() {
		feather.replace();
	},
};
</script>

<template>
	<header id="nav" class="w-full">
		<div class="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-14">
			<div
				class="flex flex-wrap justify-between items-center py-6 sm:py-7"
			>
				<!-- Logo + mobile hamburger row -->
				<div
					class="flex justify-between items-center w-full sm:w-auto"
				>
					<router-link to="/" aria-label="Anrealm — home">
						<img
							src="@/assets/images/logo-lockup.svg"
							class="h-7 sm:h-8 w-auto"
							alt="Anrealm"
						/>
					</router-link>

					<button
						v-if="!minimal"
						@click="isOpen = !isOpen"
						type="button"
						class="sm:hidden focus:outline-none text-ink"
						aria-label="Menu"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 24 24"
							class="h-7 w-7 fill-current"
						>
							<path
								v-if="isOpen"
								fill-rule="evenodd"
								d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"
								clip-rule="evenodd"
							></path>
							<path
								v-if="!isOpen"
								fill-rule="evenodd"
								d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
							></path>
						</svg>
					</button>
				</div>

				<!-- Nav links -->
				<AppHeaderLinks v-if="!minimal" :isOpen="isOpen" />
			</div>
		</div>
	</header>
</template>

<style scoped></style>
